import type {
  TLeasingOrderDetailed,
  TLeasingOrderResponse
} from '@/components/App/Leasing/types';
import { type OfferCard } from '@/components/Shared/ui';
import { formatPrice } from '@/services/formatter';

export const getLeasingOfferBodyProducts = ({
  leasingOffer,
  mobileAlternatives,
  request
}: {
  leasingOffer: TLeasingOrderResponse;
  mobileAlternatives: boolean;
  request: TLeasingOrderDetailed | null;
}) => {
  const {
    balloonAmount,
    firstMonthPayment,
    rate,
    loanPeriod,
    approvedAmount,
    initialPayment
  } = leasingOffer;
  const { initialPayment: requestInitialPayment } = request || {};

  const products = [
    {
      title: mobileAlternatives ? 'Платеж в мес.' : 'Ежемесячный платеж',
      productValue: firstMonthPayment ?? '-',
      descriptionFormatter: (value: string | number) =>
        `${formatPrice(value)} ₸`
    },
    {
      title: mobileAlternatives ? 'Ставка' : 'Процентная ставка',
      productValue: rate ?? '-',
      descriptionFormatter: (value: string | number) => `${value}%`,
      isRed: true
    },
    {
      title: mobileAlternatives ? 'Срок' : 'Срок лизинга',
      productValue: loanPeriod ?? '-',
      descriptionFormatter: (value: string | number) => `${value} месяца`
    },
    {
      title: 'Сумма займа',
      productValue: approvedAmount ?? '-',
      descriptionFormatter: (value: string | number) =>
        `${formatPrice(value)} ₸`
    },
    {
      title: 'Авансовый взнос',
      productValue: initialPayment ?? requestInitialPayment ?? '-',
      descriptionFormatter: (value: string | number) =>
        `${formatPrice(value)} ₸`
    },
    {
      title: 'Остаточная стоимость',
      productValue: balloonAmount ?? '-',
      descriptionFormatter: (value: string | number) =>
        `${formatPrice(value)} ₸`
    }
  ];

  return products.map(
    (item) =>
      ({
        ...item,
        description:
          item.productValue != null
            ? item.descriptionFormatter(item.productValue)
            : ''
      }) satisfies React.ComponentProps<
        typeof OfferCard.Body
      >['products'][number] & {
        productValue: string | number | null | undefined;
        descriptionFormatter: (value: string | number) => string;
      }
  );
};
